import type { NodeType } from '@atlaskit/editor-prosemirror/model';
import type { EditorState, Selection } from '@atlaskit/editor-prosemirror/state';
import { expValEqualsNoExposure } from '@atlaskit/tmp-editor-statsig/exp-val-equals-no-exposure';

export const getSupportedNodesForAIModal = ({ schema: { nodes } }: EditorState) => {
	if (
		expValEqualsNoExposure('platform_editor_rovobutton_smartlink_toolbar_exp', 'isEnabled', true)
	) {
		return new Set<NodeType>(
			[nodes.table, nodes.inlineCard, nodes.blockCard, nodes.embedCard].filter(Boolean),
		);
	} else {
		return new Set<NodeType>([nodes.table]);
	}
};

export const isCellSelection = (state: EditorState, selection?: Selection): boolean => {
	const { tableHeader, tableCell, tabeRow, table } = state.schema.nodes;
	const { $from } = selection || state.selection;
	const parent = $from.parent;
	return [tableHeader, tableCell, tabeRow, table].includes(parent.type);
};
